import React from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/sections/Header";
import Footer from "@/components/sections/Footer";
import Seo from "@/components/Seo";
import { PRIVACY, TERMS } from "@/lib/legalContent";
import { openCookiePreferences } from "@/lib/consent";

const K = { fontFamily: "Kanit, Arial, sans-serif" };
const S = { fontFamily: "'Noto Serif', Georgia, serif" };

const PAGES = { "/privacy": PRIVACY, "/terms": TERMS };

export default function Legal() {
  const { pathname } = useLocation();
  const page = PAGES[pathname] || PRIVACY;

  return (
    <main data-testid="legal-page" className="min-h-screen bg-[#F5EFE7] text-[#451C25]">
      <Seo title={`${page.title} | Destino Europe`} description={page.intro} path={pathname} noindex />
      <Header />
      <section className="pt-40 pb-24 px-6 md:px-10 lg:px-14">
        <div className="max-w-3xl mx-auto">
          <h1 data-testid="legal-title" className="text-4xl sm:text-5xl tracking-tight" style={{ ...K, fontWeight: 600 }}>{page.title}</h1>
          <p data-testid="legal-updated" className="mt-4 text-[#897756] text-[11px] tracking-[0.18em] uppercase" style={K}>Last updated: {page.updated}</p>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-[#6B4954]" style={S}>{page.intro}</p>
          <ol data-testid="legal-sections" className="mt-10 space-y-8">
            {page.sections.map((s, i) => (
              <li key={s.h} className="border-t border-[#451C25]/15 pt-6">
                <h2 className="text-lg md:text-xl" style={{ ...K, fontWeight: 500 }}>{i + 1}. {s.h}</h2>
                <div className="mt-3 space-y-3 text-[15px] md:text-base leading-relaxed" style={S}>
                  {s.p.map((para, j) => <p key={j}>{para}</p>)}
                </div>
              </li>
            ))}
          </ol>
          {pathname === "/privacy" && (
            <div className="mt-10 border-t border-[#451C25]/15 pt-6">
              <button type="button" data-testid="legal-cookie-preferences" onClick={openCookiePreferences} className="text-[12px] tracking-[0.2em] uppercase font-semibold text-[#451C25] border-b border-[#B3A17D] pb-1 hover:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#B3A17D]" style={K}>Manage cookie preferences</button>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </main>
  );
}
